import { type ImageTypeFront } from '@Types/Blocks/Image';
import { type HeadingType } from '@Types/Shared/Heading';

import Heading from '@Shared/Heading/Heading';

import Html from '@/views/Shared/Html';

export default function ImageBg(props: ImageTypeFront) {
	const {
		id,
		title,
		titleFormat,
		description,
		imageUrl,
		imageAlt,
		inside_title,
		inside_titleFormat,
		inside_description,
		containerType,
		headingAlign,
		headingFontClassName,
		contentFontClass,
		context,
		sectionDecoration,
	} = props;

	const headingProps: HeadingType = {
		title: title,
		description: description,
		titleFormat: titleFormat,
		headingAlign: headingAlign,
		headingFontClassName: headingFontClassName,
		context: context,
	};

	let blockStyle = '';
	if (containerType === 'block') {
		blockStyle =
			'desktop:p-12 tablet:p-6 p-5 bg-minos-img-bg-container-color border-2 border-minos-img-container-border-color rounded-minos-img-container';
	} else {
		blockStyle = '';
	}

	let padding = '';
	if (sectionDecoration?.isSectionDecorated && sectionDecoration.type === 'wave') {
		padding = 'pt-12 pb-16 tablet:pt-12 tablet:pb-24 desktop:pt-24 desktop:pb-40';
	} else {
		padding = 'py-5 tablet:py-12 desktop:py-24';
	}

	return (
		<div id={id} className={`minos-grid relative bg-minos-img-bg-color ${padding}`}>
			<div data-aos='fade-up' className={`relative z-[11] col-start-2 col-end-14 ${blockStyle}`}>
				{/* mobile breakpoints handle in component */}
				<Heading {...headingProps} />

				<img
					className='aspect-[5/3] w-full rounded-t-minos-img-img object-cover'
					src={imageUrl}
					alt={imageAlt}
				/>

				{inside_title || inside_description ? (
					<div className='w-full rounded-b-minos-img-img bg-minos-img-bg-legend-color p-5 tablet:p-7'>
						{inside_titleFormat === 'h2' ? (
							<h2 className={`${contentFontClass?.title} text-3xl`}>{inside_title}</h2>
						) : (
							<h3 className={`${contentFontClass?.title} text-2xl`}>{inside_title}</h3>
						)}

						<div data-content='minos-content' className='mt-2'>
							<Html context='img' className={contentFontClass?.text} html={inside_description} />
						</div>
					</div>
				) : (
					''
				)}
			</div>
		</div>
	);
}
